import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { Observable, of, switchMap } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { DistrictService } from '../../services/districtService';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
@Component({
  selector: 'app-districts-data',
  templateUrl: './districts.component.html',
  standalone: true,
  styleUrl: './districts.component.scss',
  imports: [DialogModule, DatepickerComponent, DatePickerModule, TableModule, ToastModule, DatePickerModule, TagModule, SelectModule, ButtonModule, InputTextModule, FormsModule, TableComponent, DropdownComponent, ProgressSpinnerModule, SelectModule, ConfirmPopupModule],
  providers: [MessageService, DistrictService, DatePipe, ConfirmationService]
})
export class DistrictsComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;

  router: any;
  param: any;
  userId: any;
  processMessage: string = "";
  lsNorthDataColumns: any[] = [];
  criticalLoadDataCommentColumns: any[] = [];
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  // comments$: any[] = [];
  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  districtOptions: SelectItem[] = [];
  schuduledDateOptions: SelectItem[] = [];
  dispatchViewOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  selectedDistrict: any;
  selectedScheduledDate: string = "";
  selectedDispatchView: any;
  selectedType: any;
  allDistrictData: any[] = [];
  filteredData$!: Observable<any[]>; // = [...this.allDistrictData];
  queryData: any = {};
  currentPage: number = 1;
  selectDate: string = "Select a Date";
  sortField: string = "";
  sortOrder: number = 1;
  searchText: any = "";

  constructor(
    private route: ActivatedRoute,
    private districtService: DistrictService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService, private datePipe: DatePipe, private apiService: ApiService,
    private confirmationService: ConfirmationService
  ) {

    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      //  this.user = this.clsService.getUser();
      this.tblConfig.searchValue = this.param;

    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);
    this.queryData = temp;

    if (temp) {
      this.selectedDistrict = temp.data.DistrictNm;
      this.selectedDispatchView = temp.data.Dispatch_Status;
      this.selectedScheduledDate = temp.data.Sched_Date;
      this.selectedType = temp.data.Type;
      this.getSelectedDistrictDetails(temp.data.DistrictNm);
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.LoadDistrictDetails();
  }

  showDialog() {
    this.dialogVisible = true;
  }

  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.lsNorthDataColumns = [
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "DispatchStatus", "header": "DISPATCH STATUS", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      {
        "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action", isClickable: 'true',
        onclick: this.handleClick.bind(this)
      }
    ];

    this.commentTable = [
      { "field": "message", "header": "USER COMMENTS", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdUser", "header": "CREATE BY", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdDate", "header": "CREATE DATETIME", "filter": true, "isSorting": true, "width": "5%" },
    ]
  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);
    const temp = {
      data: {
        DistrictNm: this.selectedDistrict,
        Sched_Date: this.selectedScheduledDate,
        Dispatch_Status: this.selectedDispatchView,
        Type: this.selectedType
      },
      from: "/districts"
    }

    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  uniqueData(data: any) {
    const uniqueData = data.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.label === value.label && t.value === value.value
      ))
    );

    const sortedData = uniqueData.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return sortedData;
  }
  sortedDate(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);

      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }
  removeDuplicateValues(data: any) {

    return data.reduce((acc: any, current: any) => {
      if (!acc.some((item: any) => item.label === current.label)) {
        acc.push(current);
      }
      return acc;
    }, []);
  }

  LoadDistrictDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;


    this.apiService.groupId().pipe(
      switchMap(groupId => {
        this.userId = groupId;
        return this.districtService.getDistricts(this.userId);
      })
    ).subscribe({
      next: (data: any) => {
        this.districtsMainCollection = data?.Payload;
        this.districtOptions = this.uniqueData(data?.Payload.DistrictData.map((district: any) => ({
          label: district.District.trim(),
          value: district.District
        })));
        this.dispatchViewOptions = this.uniqueData(data?.Payload.DispatchStatusData.map((Status: any) => ({
          label: Status.Value.trim(),
          value: Status.Value
        })));
        this.typeOptions = this.uniqueData(data?.Payload.OrderTypeData.map((type: any) => ({
          label: type.Value.trim(),
          value: type.Value
        })));
        this.isLoading = false;
        this.updateDropdownValues();
        if (this.queryData) {
          this.updateDropdownValuesForLoad();
          this.queryData = undefined;
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'DistrictsComponent.LoadDistrictDetails', message: error }, SeverityLevel.Error);
        this.isLoading = false;
      },
      complete: () => { this.isLoading = false; }
    });

  }

  sortedData(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);

      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    })?.reverse();
  }

  updateDropdownValuesForLoad() {

    const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim());
    this.schuduledDateOptions = this.uniqueData(tempData.map((district: any) => ({
      label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
      value: district.SchedDate?.trim()?.toString()
    })));

    const sortedScheduledData = this.sortedData(this.schuduledDateOptions);
    this.schuduledDateOptions = this.removeDuplicateValues(sortedScheduledData);
    const tempData1 = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.SchedDate?.trim() === this.selectedScheduledDate?.trim());
    this.dispatchViewOptions = this.uniqueData(tempData1.map((district: any) => ({
      label: district.DispatchStatus.trim(),
      value: district.DispatchStatus
    })))

    const tempData2 = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.SchedDate?.trim() === this.selectedScheduledDate?.trim() && item.DispatchStatus?.trim() === this.selectedDispatchView?.trim());
    this.typeOptions = this.uniqueData(tempData2.map((district: any) => ({
      label: district.Type.trim(),
      value: district.Type
    })));

  }

  updateDropdownValues() {
    if (this.selectedDistrict !== "" && this.selectedScheduledDate === "" && this.selectedDispatchView === "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim());
      this.schuduledDateOptions = this.uniqueData(tempData.map((district: any) => ({
        label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
        value: district.SchedDate?.trim()?.toString()
      })));

      const sortedScheduledData = this.sortedData(this.schuduledDateOptions);
      this.schuduledDateOptions = this.removeDuplicateValues(sortedScheduledData);
      this.dispatchViewOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.DispatchStatus.trim(),
        value: district.DispatchStatus
      })))

      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));
    }

    if (this.selectedDistrict !== "" && this.selectedScheduledDate !== "" && this.selectedDispatchView === "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.SchedDate?.trim() === this.selectedScheduledDate?.trim());
      this.dispatchViewOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.DispatchStatus.trim(),
        value: district.DispatchStatus
      })))

      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));
    }

    if (this.selectedDistrict !== "" && this.selectedScheduledDate !== "" && this.selectedDispatchView !== "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.SchedDate?.trim() === this.selectedScheduledDate?.trim() && item.DispatchStatus?.trim() === this.selectedDispatchView?.trim());
      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));
    }
  }

  getSelectedDistrictDetails(districtNm: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          DistrictNm: districtNm === "" ? null : districtNm,
          Sched_Date: this.selectedScheduledDate === "" ? null : this.selectedScheduledDate,
          Dispatch_Status: this.selectedDispatchView === "" ? null : this.selectedDispatchView,
          Type: this.selectedType === "" ? null : this.selectedType,
          UserId: sessionStorage.getItem('userId'),
          PageNumber: this.currentPage,
          PageSize: this.pageSize,
          groupId: groupId,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText
        };
        return this.districtService.getDistrictDetails(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const totalRec = data?.Payload?.TotalRecords;
        const updatedData = data?.Payload?.Data.map((item: any) => {
          return {
            ...item,
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });
        this.filteredData$ = of(updatedData);
        this.totalRecords = totalRec;
        this.isLoading = false;
        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'DistrictsComponent.getSelectedDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;

      }
    });
  }

  onCellClicked(event: any[]) {
    this.isLoading = true;
    this.cellValue = event;
    this.selectedRow = event[1];
    //  this.getComments(this.selectedRow.bqUniqueId);
  }

  onCancelCommentClicked() {
    this.txtComment = "";
    this.dialogVisible = false;
  }

  onSaveCommentClicked() {
    this.isLoading = true;
    const cmt = { bqUniqueId: this.selectedRow.bqUniqueId, message: this.txtComment, createdUser: this.user, createdDate: Date() };
    if (cmt === null || cmt === undefined) {
      this.messageService.add({ severity: 'warning', summary: 'warning', detail: environment.appMessages.noChangesFound, life: environment.appSettings.snakbarLife });
      return;
    }

    this.processMessage = environment.appMessages.savinggMesage;
    this.isLoading = false;
  }

  reload() {
    this.tblConfig.clear();
    this.selectedItems = [];
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
    this.updateDropdownValues();
  }

  onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
    this.updateDropdownValues();
  }

  onDispatchViewChange(event: any) {
    this.selectedDispatchView = event;
    this.updateDropdownValues();
  }
  getSearchDisabledStatus() {
    return this.selectedDistrict === "" || this.selectedScheduledDate === "" || this.selectedDispatchView === "" || this.selectedType === ""
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onSearch(): void {
    this.currentPage = 1;
    this.tblConfig.resetPage();
    this.getSelectedDistrictDetails(this.selectedDistrict);
  }

  onClear(): void {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {

        this.selectedScheduledDate = "";
        this.selectedType = "";
        this.selectedDispatchView = "";
        this.selectedScheduledDate = "";
        this.selectedDistrict = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },

    });


  }

  onPageChanged(event: any): void {
    const pageSize = event.pageSize;
    const pageNumber = event.page;
    //const pageNumber = pageIndex + 1; // convert to one-based 
    console.log('Page:', pageNumber, 'Page Size:', pageSize);
    this.currentPage = pageNumber;
    this.pageSize = pageSize;
    this.getSelectedDistrictDetails(this.selectedDistrict);
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.currentPage = 1;
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.getSelectedDistrictDetails(this.selectedDistrict);
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedDistrictDetails(this.selectedDistrict);

  }
}
